<script setup lang="ts">
import sanitizeHtml from 'sanitize-html'

const props = defineProps<{
	id: string
	fallback?: string
	system?: any
}>()

const text = useServerText(props.id, props.fallback)

const sanitizedText = computed(() => {
	if (!text.value) return props.fallback

	const content = props.system ? replacePlaceholder(text.value, props.system) : text.value

	return sanitizeHtml(markdownToHtml(content ?? '') || '', {
		allowedTags: ['a', 'br', 'strong', 'sub'],
		allowedAttributes: { a: ['href', 'class', 'target', 'rel'] },
	})
})
</script>

<template>
	<span :id="id">
		<span v-html="sanitizedText"></span>
		<CommonAdminEditLink :to="`/admin/cms/texts#${id}`" :title="`Text ${id} bearbeiten`" inline />
	</span>
</template>
